import React, { Component } from "react"
import { kupatHolim, healthIssues, bltLevel, btlAck } from '../../variables/ComboValues'
import { updateElement } from "../Tree/Utils.js"
import { box_element } from './ParentEmployment'



// TODO: get data from DB && Update to DB
export const  HealthStatus_microLegend = {
      "parent_health": "מצב בריאותי",
      "parent_bituachleumi": "אי כושר עבודה או אי כושר השתכרות בבט''ל?",
      "parent_bituachleumi_temp": "הכרה זמנית/קבועה",
      "parent_kupat_holim": "קופת חולים",
    "comment": "הערות"
}
const emptyItem = {
    "id": 1,
    "parent_health": "",
    "parent_bituachleumi":  "",
    "parent_bituachleumi_temp":  "",
    "parent_kupat_holim":  "",
  "comment":  "",
}
export class ParentHealthStatus extends Component {

    constructor(props) {
      super(props)
      this.state = { products: this.props.data === "undefined" ? emptyItem : this.props.data } 
      this.onSaveTable = this.onSaveTable.bind(this)
      this.handleProductTable = this.handleProductTable.bind(this)
    }
    
    handleProductTable(evt) {
        evt.preventDefault()
        var newp= updateElement(evt, this.state.products)
        this.setState({products:newp})
    }

    // update data base
    onSaveTable(evt) {
      evt.preventDefault()
      const { save2DB, subTableId, memberPostId } = this.props
      // console.log("Family General save table: products", this.state.products)
      save2DB(memberPostId, this.state.products, subTableId, "group" )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      // console.log("Family general data", data)
      // console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable} 
            tableTitle = {tableTitle} // "סיכומי מפגשים"
            products={this.state.products} 
          />
      )
    }
  }
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
    }
    
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, products, tableTitle, onSaveTable } = this.props
      
      const product = products
      if (typeof product.id === "undefined"){
        product.id=1
        //console.log("paRENTMGR product ID is undefined")
      }
      const cellData=[{
        type: "select",
        options: healthIssues, // ["אין בעיות מיוחדות","יש מחלה כרונית","קיימות מגבלות פיזיות","קיימות בעיות בריאותיות אחרות","אחר"],
        name: "parent_health",
        value: product.parent_health,
        id: product.id,
        style: {width: "90px"},
        edit: true
      },{
        type: "select",
        options: bltLevel, // ["לא","כן, בדרגה של 60%","כן, בדרגה של 65%","כן, בדרגה של 74%","כן, בדרגה של 100%","אחר"],
        name: "parent_bituachleumi",
        value: product.parent_bituachleumi,
        id: product.id,
        style: {width: "200px"},
        edit: true
      },{
        type: "select",
        options: btlAck, // ["זמני","קבוע","אין הכרה","אחר"],
        name: "parent_bituachleumi_temp",
        value: product.parent_bituachleumi_temp,
        id: product.id,
        style: {width: "90px"},
        edit: true
      },{
        type: "select",
        options: kupatHolim, // ["מאוחדת","כללית","לאומית","מכבי","לא מבוטח בקופת חולים כלשהי","אחר"],
        name: "parent_kupat_holim",
        value: product.parent_kupat_holim,
        id: product.id,
        style: {width: "90px"},
        edit: true
      },{
        type: "textarea",
        name: "comment",
        value: product.comment,
        id: product.id,
        style: {width: "300px"},
        edit: true
      }] 
          
      return (box_element(tableTitle, onSaveTable, onProductTableUpdate, product, cellData, HealthStatus_microLegend ))

    }
  }
